// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2jc2v","label":"Completed_label__33puK"};